// extracted by css-extract-rspack-plugin
export default {"emptyState":"StlSzAbv1O0UfTlA","loading":"MYl6Q0WHDPsotkIg"};